import { motion } from "framer-motion";

const quotes = [
  {
    q: "After my knee surgery this was the only training that didn't hurt. Six weeks in and I'm stronger than before the injury.",
    name: "Mariana R.",
    role: "Marathon runner, in rehab",
  },
  {
    q: "I'm 71 and I move better than I did at 55. The gentle sessions are perfect and my balance has completely changed.",
    name: "George W.",
    role: "Retired, water yoga daily",
  },
  {
    q: "The metrics are addictive. I finally see my stroke rate improving and my dryland lifts went up too.",
    name: "Aisha K.",
    role: "Competitive swimmer",
  },
];

export const Testimonials = () => {
  return (
    <section id="voices" data-testid="testimonials" className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
      <div className="mb-16 max-w-2xl">
        <p className="mb-4 text-xs font-600 uppercase tracking-[0.3em] text-aqua">Voices from the water</p>
        <h2 className="font-display text-4xl font-800 leading-[0.95] tracking-tight text-textMain md:text-6xl">
          Loved across every lane.
        </h2>
      </div>

      <div className="grid gap-5 md:grid-cols-3">
        {quotes.map((t, i) => (
          <motion.figure
            key={i}
            data-testid={`testimonial-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col justify-between rounded-2xl border border-textMuted/20 bg-surface/40 p-8"
          >
            <blockquote className="font-serif-italic text-xl leading-relaxed text-textMain md:text-2xl">
              "{t.q}"
            </blockquote>
            <figcaption className="mt-8 border-t border-textMuted/15 pt-5">
              <div className="font-700 text-textMain">{t.name}</div>
              <div className="text-sm text-textMuted">{t.role}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
